import React from 'react';
import { CircularProgress, Typography, Box } from '@mui/material';

const LoadingError = ({ isLoading, error }) => {
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh', // Full viewport height
          width: '100%', // Full width
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh', // Full viewport height
          width: '100%', // Full width
        }}
      >
        <Typography variant="h6" color="error">
          {error.message || 'Something went wrong!'}
        </Typography>
      </Box>
    );
  }

  return null; // When there's no loading or error
};

export default LoadingError;
